// AJAX CART

//DOM ELEMENTS

// Add To Cart Form - used throughout website so will work for all.
const addToCartForm = document.querySelectorAll('#product-form');

// Add To Cart Form Upsells - used throughout website so will work for all.
const addonForm = document.querySelectorAll('#addon-form');

//Slide Cart Wrapper
const slideCartWrapper = document.querySelector('.slide-cart-wrapper');

addToCartForm.forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    document.getElementById('addToCartButton').textContent = "ADDING..";

    // Submit the form with AJAX
      await fetch("/cart/add", {
        method: "POST",
        body: new FormData(form),
      });

    //Update Cart Count Header
      updateHeaderCartCount();
      
    // Update Slide Cart
      updateSlideCart();

    // Open
      openSlideCart();

    // Rename Button
    document.getElementById('addToCartButton').textContent = "ADD TO BASKET";

  });
});

// Open Slide Cart
function openSlideCart() {
  slideCartWrapper.classList.add("slide-cart--active");
  document.body.style.overflowY = "hidden";
}

// Close Slide Cart
function closeSlideCart() {
  slideCartWrapper.classList.remove("slide-cart--active");
  document.body.style.overflowY = "scroll";
}

// Update Cart Count in Header
async function updateHeaderCartCount() {
  // Get New Cart Object
    const res = await fetch("/cart.json");
    const cart = await res.json();

  document.querySelectorAll(".header-cart-item-count").forEach(el => {
    el.textContent = cart.item_count;
  });
}

// Slide Cart Listeners
  async function slideCartListeners() {

    // Update Quantity Input
    document.querySelectorAll('.slide-cart-quantity-selector button').forEach((button) => {
      button.addEventListener('click', async () => {

    // Get Line item Key
    const rootLineItem = button.closest("#slide-cart-item").getAttribute("slide-cart-line-item-key");

    // Get Original Item Invventory for Stock Checking
    let originalItemInventory = document.querySelector(".slide-cart-quantity-selector").getAttribute("inventory-quantity");

    // Error Messge Max QTY Reached
    const maxQTY = document.querySelector(".item-qty-max-reached");

    // Get New Quantity to Check Inventory

    const currentQty = Number(button.parentElement.querySelector('input[name="updates[]"]').value);

    const isUp = button.classList.contains('slide-cart-quantity-selector-plus');

    const newQty = isUp ? currentQty + 1 : currentQty - 1;
      
    // Update QTY with AJAX
      const res = await fetch('/cart/update.js', {
      method: "POST",
      headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [rootLineItem]: newQty } }),
    });

    // Update Slide Cart
      updateSlideCart();

    // Update Header Cart Count
      updateHeaderCartCount();

  });
    
  async function removeItem(key, quantity, item) {
    // Remove with AJAX
      const res = await fetch('/cart/update.js', {
        method: "POST",
        headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [key]: quantity } }),
    });

    const cart = await res.json();

      if (cart.items.length === 0) {
        closeSlideCart();
        updateSlideCart()
        updateHeaderCartCount();
      } else {
        updateHeaderCartCount();
        const format = document.querySelector('[data-money-format]').getAttribute('data-money-format');
        const totalPrice = formatMoney(cart.total_price, format);
        document.querySelector(".slide-final").textContent = totalPrice;
        item.remove();
      }
    }

        
// Remove Product
  document.querySelectorAll(".slide-cart-remove").forEach((remove) => {
    remove.addEventListener("click", (e) => {
      e.preventDefault();

      const item = remove.closest(".slide-cart-item");
      const key = item.getAttribute('slide-cart-line-item-key');
      removeItem(key, 0, item);

      });
      
    });

  });

  // Stop Inner Slide Cart closing cart
    document.querySelector(".slide-cart-inner-wrapper").addEventListener("click", (e) => {
      e.stopPropagation();
    });

  // Close Slide Cart
    document.querySelectorAll(".slide-cart-close, .slide-cart-wrapper").forEach((close) => {
      close.addEventListener("click", () => {
        closeSlideCart();
      });
    });

}

slideCartListeners();

// Open Slide Cart
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
      e.preventDefault();
      openSlideCart();
  })
})

// Update Slide Cart Inner Item HTML
  async function updateSlideCart() {
  const res = await fetch("/?section_id=template-slide-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newItems = html.querySelector(".slide-cart-wrapper").innerHTML;
  slideCartWrapper.innerHTML = newItems;
  slideCartListeners();
}

// Add-On Form - used throughout website so will work for all.
addOn();

// Addon Form Submit (within slide out cart)
function addOn() {
  // Addon Form Submit (within slide out cart)
  
  addonForm.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
    
      form.querySelector('#addon-btn').textContent = "ADDING...";
    
      // Submit the form with AJAX
        await fetch("/cart/add", {
          method: "POST",
          body: new FormData(form),
        });
    
      // Get New Cart Object
        const res = await fetch("/cart.json");
        const cart = await res.json();

      //Update Cart Count Header
        updateHeaderCartCount();
      
      // Update Slide Cart
        updateSlideCart();

      // Rename Button
        form.querySelector('#addon-btn').textContent = "ADD TO CART";

      // Update Slide Cart
        openSlideCart();
      
    });
  });
};
  

// Format Monies

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};